import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { change } from 'redux-form';
import _get from 'lodash/get';
import { chatActions, chatSelectors, nucleusConstants, featureSelectors } from '@lifesize/nucleus';
import { hooks } from '@lifesize/clients.sdk';
import { selectConversationContactDialString, setChatMode, setFormFocus } from 'actions/Chat';
import contactActions from 'actions/Contact';
import { openFullScreenModal } from 'actions/FullScreenModal';
import ChatConversationHeader from 'components/Chat/ChatConversationHeader';
import { CHAT_SEARCH_FORM } from 'constants/Chat';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { currentConversationDialStringSelector } from 'selectors/chat';
import actions from 'actions/FullScreenModal';
import { DELETE_CHAT_MODAL } from 'constants/Chat';
import { FEATURE_FLAG_ENABLE_CHAT_DELETION } from 'constants/FeatureFlags';

function mapDispatchToProps(dispatch) {
  return {
    onLeaveConversation: (contact) => dispatch(chatActions.leaveConversation(contact)),
    onSelectContact: (contact, autoSelect = false) => {
      if (contact) {
        dispatch(setChatMode());
        dispatch(chatActions.enterConversation(contact));
        dispatch(selectConversationContactDialString(contact.dialString));
        dispatch(change(CHAT_SEARCH_FORM, 'chatSearchBar', ''));
        setFormFocus(false);
      } else if (!autoSelect) {
        dispatch(setChatMode('search'));
      }
    },
    openScheduleModal: (id) => {
      dispatch(openFullScreenModal(SCHEDULE_MODAL, id));
    },
    handleAudioCall: (contact) => {
      dispatch(contactActions.startAudioCall(contact));
    },
    handleVideoCall: (contact) => {
      dispatch(contactActions.startVideoCall(contact));
    },
    handleDeleteChat: (contact) => {
      dispatch(actions.openFullScreenModal(DELETE_CHAT_MODAL, contact));
    }
  };
}

function mapStateToProps(state, ownProps) {
  const conversationContactDialString = currentConversationDialStringSelector(state);
  const conversationMode = _get(state, 'app.chat.conversationMode');
  const conversation = chatSelectors.getChatForWebGenerator(state)(conversationContactDialString);
  const isMeeting = conversation && _get(conversation, 'contact.isMeeting');
  const isOneTimeMeeting = conversation && conversation.meetingType === nucleusConstants.MEETING_TYPE_ONE_TIME;
  const enableChatDeletion = featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ENABLE_CHAT_DELETION);

  return {
    ...ownProps,
    conversation,
    isMeeting,
    isOneTimeMeeting,
    mode: conversationMode,
    scrollBookmarks: _get(state, 'app.chat.scrollBookmarks'),
    enableChatDeletion
  };
}

const ConnectedComponent = injectIntl(connect(mapStateToProps, mapDispatchToProps)(ChatConversationHeader));

const FunctionalWrapper = (props) => {
  const isCallConnected = hooks.useCallConnected();
  const currentUserParticipant = hooks.useCurrentUserParticipant();
  return (
    <ConnectedComponent isCallConnected={isCallConnected} isInCallParticipants={!!currentUserParticipant} {...props} />
  );
};

export { ConnectedComponent as ChatConversationHeaderContainer };
export default FunctionalWrapper;
